interface Neighborhood {
  name: string;
  note: string;
}

interface LocationNeighborhoodsProps {
  city: string;
  neighborhoods: Neighborhood[];
}

const LocationNeighborhoods = ({ city, neighborhoods }: LocationNeighborhoodsProps) => (
  <section className="py-16 bg-muted/50">
    <div className="container mx-auto px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-foreground mb-6">
          {city} Neighborhoods We Serve
        </h2>
        <div className="space-y-4">
          {neighborhoods.map((n) => (
            <div key={n.name}>
              <h3 className="text-xl font-semibold text-foreground">{n.name}</h3>
              <p className="text-muted-foreground">{n.note}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default LocationNeighborhoods;
